document.documentElement.classList.remove('no-js');

window.addEventListener('DOMContentLoaded', () => {
  const collectionLanding = document.querySelector('[data-collection-landing], .opc-alpha-landing');
  if (collectionLanding) {
    document.documentElement.classList.add('opc-collection-page');
    document.body.classList.add('opc-collection-page', 'has-collection-landing');
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('.mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
});
